export const initialState = () => ({ selectedEmailTemplateId: null, templates: {}, publicEmailTemplates: {} });

const state = initialState();

export default state;
